// tslint:disable
export var TCSSource;
(function (TCSSource) {
    // Unknown
    TCSSource[TCSSource["Unknown"] = 0] = "Unknown";
    // Janssen CarePath One Patient Portal
    TCSSource[TCSSource["Patient"] = 5] = "Patient";
    // Janssen CarePath One Provider Portal
    TCSSource[TCSSource["Provider"] = 6] = "Provider";
    // Janssen CarePath One Hub Portal
    TCSSource[TCSSource["Hub"] = 7] = "Hub";
    // Janssen CarePath One Express Portal
    TCSSource[TCSSource["Express"] = 8] = "Express";
    // Opus Migration
    TCSSource[TCSSource["OpusMigration"] = 10] = "OpusMigration";
})(TCSSource || (TCSSource = {}));
TCSSource['UNKNOWN'] = 0;
TCSSource['PATIENT'] = 5;
TCSSource['PROVIDER'] = 6;
TCSSource['HUB'] = 7;
TCSSource['EXPRESS'] = 8;
TCSSource['OPUSMIGRATION'] = 10;
//# sourceMappingURL=TCSSource.js.map